import Backend from 'backend';
import {inject} from 'aurelia-framework';
import {Router} from 'aurelia-router';
import moment from 'moment';
import {ValidationController, ValidationRules} from "aurelia-validation";

@inject(Backend, Router, ValidationController)
export class RegisterReturnedGoodsScreen {
    backend;

    saleTypes;

    command = {
        date: moment().format('YYYY-MM-DD'), // today()
        correspondingSalePeriod: null,
        lines: [
          {} // Initial empty line in gui
          ]
    };

    saveError;
    saveInProgress;

    queryError;

    router;
    validationController;

    constructor(backendFacade, router, validationController) {
        this.backend = backendFacade;
        this.router = router;
        this.validationController = validationController;
    }

    bind() {
      ValidationRules
        .ensure('date')
          .displayName('Dato')
          .required()
        .ensure('invoiceNumber')
          .displayName('Fakturanr.')
          .required()
        .on(this.command);
    }

    createSubmit() {
        return this.validationController.validate()
          .then(result => {
              if (!result.valid) {
                  return;
              }
              this.saveError = '';
              return this.backend.RegisterReturnedGoodsCommandHandler_handle(this.command)
                .then(() => this.router.navigateToRoute('registration-menu', {ok: true}))
                .catch(error => this.saveError = error.message)
                ;
          });
    }

    dismissSaveError() {
        this.saveError = null;
    }
}
